// @flow
'use strict';

import { connect } from 'react-redux';

import AlertaCertificadoExpirado from './alerta_certificado_expirado';

export default connect<*, *, *, *, *, *>()(AlertaCertificadoExpirado);
